// CREDITOS_HEADER_2810 (GROK2): saldo de créditos embaixo do nome, no canto superior direito.
// Admin/atendente = ∞; revenda = número (clicar abre Comprar créditos). Switch: private/CREDITOS_HEADER_2810_OFF.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Coins, Infinity as InfinityIcon } from 'lucide-react';
import { useAuraxFlags } from '../../lib/auraxFlags';
import { useAuth } from '../../context/AuthContext';

export default function SaldoHeader2810({ accountSummary, displayName }) {
  const flags = useAuraxFlags();
  const navigate = useNavigate();
  const auth = useAuth();
  const credits = (accountSummary || auth?.accountSummary)?.credits;
  if (!flags?.creditos_header || !credits) return null;
  const unlimited = credits.mode === 'unlimited';
  const n = Number(credits.available ?? 0);
  const valor = unlimited ? null : (Number.isFinite(n) ? n.toLocaleString('pt-BR', { maximumFractionDigits: 2 }) : '0');
  const baixo = !unlimited && n <= 0;
  const title = unlimited ? 'Créditos ilimitados' : `Saldo: ${valor} crédito(s) — clique para comprar`;
  return (
    <button type="button" className={`aurax-saldo-2810${baixo ? ' is-zero' : ''}${unlimited ? ' is-inf' : ''}`} title={title} aria-label={title}
      data-testid="header-saldo-2810" onClick={() => { if (!unlimited) navigate('/buy-credits'); }}>
      <span className="aurax-saldo-2810-name">{displayName}</span>
      <span className="aurax-saldo-2810-val">
        {unlimited ? <InfinityIcon size={15} strokeWidth={2.4} /> : <><Coins size={13} /><b>{valor}</b><small> créditos</small></>}
      </span>
    </button>
  );
}
